import DOMPurify from 'dompurify';
// Badge icons are fetched as raw SVG markup and inlined into the DOM by
// BadgeIcon (via React's raw-HTML injection) so their viewBox/dimensions can
// be recomputed. The markup is untrusted and must be sanitized before it is
// written into the DOM to avoid injecting scripts/handlers.
const sanitizeSvg = (svg) => DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
});
export const fetchIcon = async (badgeIcon) => {
    try {
        const fetchIconResponse = await fetch(badgeIcon);
        const hasLoadFailed = fetchIconResponse.status !== 200;
        const iconContent = hasLoadFailed
            ? ''
            : sanitizeSvg(await fetchIconResponse.text());
        return { hasLoadFailed, iconContent };
    }
    catch {
        return { hasLoadFailed: true, iconContent: '' };
    }
};
//# sourceMappingURL=icon.js.map